/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from "react";
import EnhancedTable from "components/common_components/Tables/EnhancedTable";
import Button from "components/common_components/Button";
import Page from "components/common_components/Page/Page";
import { useDispatch } from "react-redux";
import { notifyError, notifyInfo } from "redux/actions/Notifications";
import LoadingPage from "components/common_components/LoadingPage";
import Header from "components/common_components/Header";
import ChainOfCustodyContext from "./ChainOfCustodyContext";
import Status from "components/common_components/Status";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Grid, MenuItem, TextField } from "@material-ui/core";
import Icon from "components/common_components/Icon";
import { hasElements } from "utils/arrays";
import SearchInput from "components/common_components/SearchInput/SearchInput";

const headCells = [
    { index: 1, id: "client.fullName", label: "Client", sortable: false },
    { index: 2, id: "fileNo", label: "File No", sortable: false },
    { index: 3, id: "cocRequestType.type", label: "Type", sortable: false },
    {
        index: 4,
        id: "status",
        label: "Status",
        render: (_, { value, data }) => {
            return <Status id={value} withIcon />;
        },
        sortable: false,
    },
    {
        index: 5,
        id: "stampCreationDatetimeString",
        orderBy: "stampCreationDatetime",
        label: "Created",
    },
    {
        index: 6,
        id: "stampModificationDatetimeString",
        orderBy: "stampModificationDatetime",
        label: "Modified",
    },
];

function List() {
    const history = useHistory();
    const { path } = useRouteMatch();
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const [requestTypes, setRequestTypes] = useState([]);

    const [type, setType] = useState(null);
    const [status, setStatus] = useState("");

    const [quickFilterValue, setQuickFilterValue] = useState("");

    const onTypeChange = (e) => {
        setType(e.target.value);
    };

    const onStatusChange = (e) => {
        setStatus(e.target.value);
    };

    const onQuickFilterChange = (e) => {
        setQuickFilterValue(e.target.value);
    };

    const onClearFilters = () => {
        setType(null);
        setStatus("");
        setQuickFilterValue("");
    };

    const { CocRequests, RequestTypes, permissions, fileCaseFilter } = useContext(ChainOfCustodyContext);

    function getCocRequests(requestData, showLoader = true) {
        if (showLoader) {
            setIsLoading(true);
        }
        CocRequests.getList({
            onSuccess: (data, pageableData) => {
                setData(data);
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onInfo: (info, pageableData) => {
                setData([]);
                dispatch(notifyInfo(info));
                setPageableData(pageableData);
                setIsLoading(false);
            },
            onError: (error) => {
                dispatch(notifyError(error));
                setIsLoading(false);
            },
            data: requestData,
        });
    }

    function getRequestTypes() {
        RequestTypes.getAll({
            onSuccess: (data) => {
                setRequestTypes(data);
            },
            onError: () => {
                setRequestTypes([]);
            },
        });
    }

    useEffect(() => {
        onFilterChange();
        getRequestTypes();

        return () => {
            setData([]);
        };
    }, []);

    useEffect(() => {
        onFilterChange();
    }, [type, status]);

    function onRowClickHandler(item) {
        if (permissions.requests.view) {
            history.push(`${path}/${item.id}`);
        }
    }

    function onDeleteSuccess() {
        dispatch(notifyInfo("Removed successfully!"));
        getCocRequests();
    }

    function onDeleteError(error) {
        dispatch(notifyError(error.message));
    }

    function onDeleteHandler(selectedItems) {
        CocRequests.deleteAll({
            ids: selectedItems,
            onSuccess: onDeleteSuccess,
            onError: onDeleteError,
        });
    }

    const buildCustomFilter = (value) => {
        const customFilters = {};

        if (fileCaseFilter) {
            customFilters.module = fileCaseFilter.module;
            customFilters.fileCaseId = fileCaseFilter.fileCaseId;
        }

        if (value || typeof value === "undefined") {
            customFilters.quickFilterValue = value;
        } else {
            customFilters.quickFilterValue = quickFilterValue;
        }
        if (type) {
            customFilters.settingsCocRequestTypesId = type.id;
        }
        if (status) {
            customFilters.status = status;
        }
        return customFilters;
    };

    const onFilterChange = (value) => {
        getCocRequests({
            filter: buildCustomFilter(value),
            orderBy: "stampModificationDatetime",
            orderDirection: "desc",
            pageNumber: 0,
            pageSize: 10,
        });
    };

    return (
        <Page className="coc-list-page">
            <Header title="Chain of Custody">
                {permissions.requests.add && (
                    <Button primary onClick={() => history.push(`${path}/add/wizard`)}>
                        <Icon name="add" size="md" color="white" />
                        <span>New Request</span>
                    </Button>
                )}
            </Header>
            <div className="layout custom-filters">
                <Grid container spacing={2} alignItems="flex-end">
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField select value={type} onChange={onTypeChange} label="Type" fullWidth variant="standard" size="small">
                            <MenuItem key={-1} value={null}>
                                Select...
                            </MenuItem>
                            {hasElements(requestTypes) &&
                                requestTypes.map((rt) => (
                                    <MenuItem key={rt.id} value={rt}>
                                        {rt.type}
                                    </MenuItem>
                                ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField select value={status} onChange={onStatusChange} label="Status" fullWidth size="small">
                            <MenuItem key={-1} value={null}>
                                Select...
                            </MenuItem>
                            {["pending", "inprogress", "completed"].map((s, index) => (
                                <MenuItem value={s} key={index}>
                                    <Status id={s} withIcon />
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} />
                    <Grid item xs={12} sm={6} md={3}>
                        <SearchInput onChange={onQuickFilterChange} value={quickFilterValue} onSearch={onFilterChange} />
                    </Grid>
                    <Grid item xs={12} />
                    <Grid item xs={12} sm={6} md={2}>
                        <Button link secondary onClick={onClearFilters}>
                            Clear filters
                        </Button>
                    </Grid>
                </Grid>
            </div>
            <div className="layout coc-table">
                {isLoading && <LoadingPage />}
                {!isLoading && (
                    <EnhancedTable
                        headCells={headCells}
                        data={data}
                        defaultOrder={{ order: "desc", orderBy: "stampModificationDatetimeString" }}
                        keyColumnName="id"
                        onRowClick={onRowClickHandler}
                        onDelete={onDeleteHandler}
                        onRequestData={getCocRequests}
                        filterBuilder={buildCustomFilter}
                        pageableData={pageableData}
                        defaultRowsPerPage={10}
                        filterable={false}
                        deletable={permissions.admin}
                        selectable={permissions.admin}
                        allowSelectAll={permissions.admin}
                    />
                )}
            </div>
        </Page>
    );
}

export default List;
